// Production-safe logging utility
// In production, these could be sent to a logging service like Sentry

const isDevelopment = process.env.NODE_ENV === 'development';

export const logger = {
  error: (message, error = null) => {
    if (isDevelopment) {
      console.error(message, error);
    }
    // In production, you could send to error tracking service:
    // Sentry.captureException(error);
  },
  
  warn: (message, data = null) => {
    if (isDevelopment) {
      console.warn(message, data);
    }
  },
  
  info: (message, data = null) => {
    if (isDevelopment) {
      console.info(message, data);
    }
  }
};

export default logger;
